<template>
  <div>
    <SaveQueryDialog ref="saveQuery" @update:query="$emit('update:query', $event)" :query="query" :service="reportGenerator" />
    <v-btn :disabled="disabled" :color="buttonLabel ? 'success' : ''" @click="saveQuery()">
      <v-icon class="mr-2" :color="buttonLabel ? 'white' : 'info'">save</v-icon>
      <div class="text-capitalize">{{ buttonLabel || `${$t("Button.SaveAs")}..` }}</div>
    </v-btn>
  </div>
</template>

<script>
  import SaveQueryDialog from './SaveQueryDialog'

  import {
    makeRequestData,
    makeSelectionData,
    makeQueryDetails,
  } from '@/helpers/multiStationQuery'

  export default {
    components: {
      SaveQueryDialog,
    },
    props: {
      disabled: Boolean,
      query: Object,
      selection: Object,
      reportOptions: Object,
      buttonLabel: String,
    },
    computed: {
      reportGenerator() {
        return this.$store.getters['multistation/reportGenerator']
      },
      missingParams() {
        return this.$store.getters['multistation/missingParams']
      },
    },
    methods: {
      saveQuery() {
        let queryDetails = makeQueryDetails(this.query)
        let requestData = makeRequestData(this.selection, this.reportOptions, this.reportGenerator.Id)
        let selection = makeSelectionData(this.selection, this.missingParams)

        let optionsData = {
          selection,
          reportOptions: this.reportOptions,
        }

        this.$refs.saveQuery.show(queryDetails, requestData, optionsData)
      },
    },
  }
</script>